module.exports = __webpack_public_path__ + "img/476.183c6403.png";